// extracted by css-extract-rspack-plugin
export default {"FilterPanelRoot":"FilterPanel-module__FilterPanelRoot___pucht"};